// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerUpdatePaymentV2_banner__UAKPk","slide-in-out":"BannerUpdatePaymentV2_slide-in-out__VxZjm","fade-in-out":"BannerUpdatePaymentV2_fade-in-out__hzHLF"};